package kz.dentalcrm.app.data.network.response_model

import kotlinx.serialization.Serializable

@Serializable
data class PatientsResponse(
    val `data`: List<PatientData> = emptyList(),
    val links: PatientsLinks? = null,
    val meta: PatientsMeta? = null
)

@Serializable
data class PatientsLinks(
    val first: String? = null,
    val last: String? = null,
    val prev: String? = null,
    val next: String? = null
)

@Serializable
data class PatientsMeta(
    val current_page: Int? = null,
    val from: Int? = null,
    val last_page: Int? = null,
    val path: String? = null,
    val per_page: Int? = null,
    val to: Int? = null,
    val total: Int? = null
)
